import React from "react";
import { Button, Row, Col, Icon, Result } from "antd";
import { Link } from "react-router-dom";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const EndProcess = ({ name, finishDesing }) => {
  //To translate text
  const { t } = useTranslation();

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]} type="flex" justify="center" align="middle">
      <Col xl={8} lg={24}>
        <Result
          status="success"
          title={t('headers.design.added_to_designs', {title: name})}
          extra={[
            <Button type="primary" key="new" onClick={() => finishDesing()}>
              <Icon type="plus" />
              {t('button.new_design')}
            </Button>,
            <Link key="go-desings-link" to="list-design-process">
              <Button key="go-desings">
                <Icon type="unordered-list" />
                {t('button.go_to_designs')}
              </Button>
            </Link>
          ]}
        />
      </Col>
    </Row>
  );
};

export default EndProcess;
